import gql from 'graphql-tag';

export default gql`
  mutation deleteChannelModule($_id: UUID!) {
    deleteChannelModule(_id: $_id)
  }
`;
